import { render, staticRenderFns } from "./CognitoAuth.vue?vue&type=template&id=70bf5dea&scoped=true&"
import script from "./CognitoAuth.vue?vue&type=script&lang=ts&"
export * from "./CognitoAuth.vue?vue&type=script&lang=ts&"
import style0 from "./CognitoAuth.vue?vue&type=style&index=0&id=70bf5dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf5dea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VRow,VSlideYTransition})
